import { t } from "@hakili/i18n";
import { Skeleton, SkeletonRegion } from "@hakili/ui";

/**
 * D2's `skeletonRows(n)` (frames 03 and 87): a card of `n` rows, each a 36 px tile and three lines, in D2's grid. The loading state of a
 * list screen, said to a screen reader once (« Chargement »).
 */
export function SkeletonRows(props: { readonly rows?: number }): React.JSX.Element {
  const rows = props.rows ?? 4;
  return (
    <div
      className="overflow-hidden rounded-[var(--hk-r-lg)] border border-[color:var(--hk-line)] bg-[color:var(--hk-surface)]"
      data-testid="squelette-lignes"
    >
      <div className="px-5 pb-[18px] pt-3">
        <SkeletonRegion label={t("bank.session.chargement")} className="gap-0">
          {Array.from({ length: rows }, (_, index) => (
            <div
              key={index}
              className="grid grid-cols-[44px_1.4fr_1fr_1fr] items-center gap-4 border-b border-[color:var(--hk-line-soft)] py-3"
              data-testid="squelette-ligne"
            >
              <Skeleton shape="block" className="!h-9 !w-9" />
              <Skeleton />
              <Skeleton />
              <Skeleton className="!w-1/2" />
            </div>
          ))}
        </SkeletonRegion>
      </div>
    </div>
  );
}
